import { useEffect } from 'react';
import { Settings } from '../types';

const BG_PRESETS = [
  // design-system: intentional override — raw values define the palette; cannot reference vars
  { id: 'warm-stone', bg: '#e8e5dd', bg2: '#ddd9d0', surface: '#f2efe8', surface2: '#ece9e1' }, // design-system: intentional override
  { id: 'bone',       bg: '#efeae0', bg2: '#e6e0d2', surface: '#f7f3e8', surface2: '#f0ebde' }, // design-system: intentional override
  { id: 'mist',       bg: '#e6e8eb', bg2: '#d9dce0', surface: '#f1f3f5', surface2: '#e9ecef' }, // design-system: intentional override
  { id: 'sand',       bg: '#e9dfc9', bg2: '#dccfb2', surface: '#f3ebd9', surface2: '#ede4cd' }, // design-system: intentional override
  { id: 'slate',      bg: '#d8dde2', bg2: '#c9d0d7', surface: '#e6eaee', surface2: '#dde2e7' }, // design-system: intentional override
  { id: 'paper',      bg: '#f4f3ef', bg2: '#ebe9e2', surface: '#ffffff', surface2: '#faf9f5' }, // design-system: intentional override
  { id: 'sage',       bg: '#dfe3d9', bg2: '#d0d5c6', surface: '#ebeee4', surface2: '#e3e7da' }, // design-system: intentional override
  { id: 'blush',      bg: '#ecdfdb', bg2: '#dfceca', surface: '#f5e9e5', surface2: '#eee1dd' }, // design-system: intentional override
];

export const useTheme = (settings: Settings) => {
  useEffect(() => {
    const root = document.documentElement;
    const resolved = settings.theme === 'system'
      ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      : settings.theme;
    root.setAttribute('data-theme', resolved);
    root.setAttribute('data-density', settings.density);
    root.setAttribute('data-palette', settings.accent === 'library' ? 'library' : 'focus');

    if (resolved === 'light') {
      const preset = BG_PRESETS.find(p => p.id === settings.bgPreset) ?? BG_PRESETS[0];
      root.style.setProperty('--bg', preset.bg);
      root.style.setProperty('--bg-2', preset.bg2);
      root.style.setProperty('--surface', preset.surface);
      root.style.setProperty('--surface-2', preset.surface2);
    } else {
      ['--bg', '--bg-2', '--surface', '--surface-2'].forEach(v => root.style.removeProperty(v));
    }
  }, [settings.theme, settings.density, settings.accent, settings.bgPreset]);

  useEffect(() => {
    if (settings.theme !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => {
      document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light');
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [settings.theme]);
};
